import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import {FormattedHTMLMessage} from 'react-intl';
import BasicFormTemplate from './BasicTemplateForm.js';

class RejectedInvestment extends Component {

    constructor(props){
        super(props);
        this.state = {
            fields: {}
        };
    }

    render() {
        const rejected = (
            <div>
                <form className='pvc-form'>
                    <Row>
                        <Col className='text-center' lg={12}>
                            <FormattedHTMLMessage id="app.step_rejected_investment" description="Rejected Info" />
                            <FormattedHTMLMessage id="app.step_rejected_investment_contact" description="Rejected Contact" />
                        </Col>
                    </Row>
                </form>
            </div> 
        );

        return (
            <BasicFormTemplate>
                {rejected}
            </BasicFormTemplate>
        );
    }
}



export default RejectedInvestment;



/** WEBPACK FOOTER **
 ** ./src/components/RejectedInvestment.js
 **/